import kueche from '../assets/svg/kueche.svg';
import quickTipps from '../assets/svg/quick-tipps.svg';
import alltag from '../assets/svg/alltag.svg';
import jahreszeit from '../assets/svg/jahreszeit.svg';
import beauty from '../assets/svg/beauty.svg';
import kuren from '../assets/svg/kuren.svg';
import spa from '../assets/svg/spa.svg';
import downloads from '../assets/svg/downloads.svg';

export default function svgForBlog(blog: string) {
    switch (blog) {
        case "kueche":
            return kueche;
        case "quick-tipps":
            return quickTipps;
        case "alltag":
            return alltag;
        case "jahreszeit":
            return jahreszeit;
        case "beauty":
            return beauty;
        case "kuren":
            return kuren;
        case "spa":
            return spa;
        case "downloads":
            return downloads;
    }
    return kueche;
}